import { RadioGroup_Field_default } from "./chunk-W7PDUG3I.js";
import { RadioGroup_default } from "./chunk-25NZY6RY.js";
import { CheckableGroup_MoreButton_default } from "./chunk-PIOYGWYS.js";

// src/components/RadioGroup/index.ts
var RadioGroupComponent = RadioGroup_default;
RadioGroupComponent.Field = RadioGroup_Field_default;
RadioGroupComponent.Field.displayName = "RadioGroup.Field";
RadioGroupComponent.MoreButton = CheckableGroup_MoreButton_default;
RadioGroupComponent.MoreButton.displayName = "RadioGroup.MoreButton";
export { RadioGroupComponent };